import React from 'react';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';
import { getImage } from '@utils/media';

const VideoItem = ({ video }) => {
  const { media } = useMedia(getImage(video, 'previewImage'));

  return (
    <InfoItem description={video.url} image={media.src}>
      {video.title}
    </InfoItem>
  );
};

export default VideoItem;
